import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function TextTemplatesAPI(): BringozApi {
  return {
    base: `/textTemplates`,
    infiniteScroll: {
      address: `/textTemplates`,
      cmd: 'GET'
    },
    actions: {
      getTemplates: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      createTemplate: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      editTemplate: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      resetTemplate: {
        address: '{id}/reset',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}

angular
  .module('bringoz.admin.text-templates')
  .factory('TextTemplatesAPI', TextTemplatesAPI);
